'use client'

import { Switch } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

type Props = {
  name: string
  checked?: boolean
  className?: string
  label: string | React.ReactNode
  disabled?: boolean
  onChange: (val: boolean) => void
} & Omit<React.ComponentPropsWithoutRef<'input'>, 'onChange'>

export const Toggle = (props: Props) => {
  const { name, checked, label, onChange, disabled } = props
  function handleChange(val: boolean) {
    onChange(val)
  }
  return (
    <Switch
      name={name}
      checked={checked}
      onChange={handleChange}
      className={twMerge('group flex w-fit items-center', disabled ? 'cursor-not-allowed! opacity-30' : 'cursor-pointer')}
      disabled={disabled}
      aria-label={props['aria-label'] || (typeof label === 'string' ? label : name)}
    >
      <div className='relative inline-flex h-5 w-10 shrink-0 items-center justify-center rounded-full focus:outline-hidden'>
        <span aria-hidden='true' className={twMerge('pointer-events-none absolute size-full rounded-md')} />
        <span
          aria-hidden='true'
          className={twMerge(
            'pointer-events-none absolute mx-auto h-4 w-9 rounded-full',
            'bg-zinc-200 transition-colors duration-200 ease-in-out group-data-checked:bg-red-800 dark:bg-zinc-700',
          )}
        />
        <span
          aria-hidden='true'
          className={twMerge(
            'pointer-events-none absolute left-0 inline-block size-5 transform rounded-full',
            'border border-zinc-300 bg-white dark:border-zinc-500 dark:bg-zinc-900',
            'shadow ring-0 transition-transform duration-200 ease-in-out',
            'group-data-checked:translate-x-5',
          )}
        />
      </div>
      <span className='px-3 text-base font-normal md:text-sm'>{label}</span>
    </Switch>
  )
}
